<div class="landing-page-wrapper" id="mainPage">
  <header class="hero-section">
    <div class="hero-content">
      <div class="blue-part">
        <div class="ring-container"></div>
        <div class="club-intro">
          <h1>
            <span>Earn Rewards</span>
            <span>Let Your Shopping Give Back To You</span>
          </h1>
          <p>
            Join KingClub and start saving money effortlessly. Earn discounts on
            every purchase and unlock exclusive perks as you level up!
          </p>
          <div class="actions">
            <button mat-button class="join-btn" (click)="joinKingClubBtnClicked()">
              Join Now
            </button>
          </div>
        </div>
      </div>

      <div class="grey-part">
        <div class="image-column">
          <img
            src="{{ kingAssets.JumpingWoman }}"
            alt="Jumping Woman"
            class="jumping-woman"
            />

            <!-- Split Text -->
            <span class="reward-part part-rew slide-in-left">Rew</span>
            <span class="reward-part part-ard slide-in-right">ard</span>
            <span class="poppins-bold program-text emerge-from-behind">Program</span>

             @defer(){
               <div class="badge-section">
                 <img src="{{ kingAssets.Avatars }}" alt="member avatars" />
                 <span>
                   +<span
                   [countUp]="membersCount"
                   [duration]="membersDuration"
                 ></span>
                 &nbsp; Members
               </span>
              </div>
             }@placeholder {
              <div class="badge-section">
                <img src="{{ kingAssets.Avatars }}" alt="member avatars" />
                <span>
                  +{{ membersCount }}<span
                ></span>
                &nbsp; Members
              </span>
             </div>
             }
        </div>
      </div>
    </div>

    <a class="home-link" [routerLink]="['/']">
      <img
        src="{{ kingAssets.KingLogoBlue }}"
        alt="kingiftcard home page link"
        />
      </a>

      <button matButton class="join-btn fixed" (click)="joinKingClubBtnClicked()">
        Become A Member
      </button>
    </header>

    <main>
      <section class="summary">
        @for (item of summaryItems; track item; let lastItem = $last) {
          <span>{{ item }}</span>
          @if (!lastItem) {
            <div class="yellow-dot-divider"></div>
          }
        }
      </section>

      <section class="rewards">
        <div class="rewards-image">
          <img src="{{ kingAssets.Rewards }}" alt="rewards" />
        </div>
        <div class="rewards-info">
          <h2 class="font-regular">
            What Is KingClub <span class="blue-keyword">Rewards System?</span>
          </h2>
          <p>
            At KingClub, we believe loyalty should be rewarded. That’s why every
            time you buy a gift card, we return a portion of your payment back to
            you — to spend however you like, whenever you want. It’s effortless,
            automatic, and made for smart shoppers like you.
          </p>
        </div>
        <div class="level-info">
          <h2 class="font-regular">
            Elevate Your Experience, Earn
            <span class="blue-keyword">More</span> As You Go.
          </h2>
          <p>
            With every purchase, you unlock more: better discounts, exclusive
            perks, and rewards made for your level. Keep shopping, keep climbing;
            the best of Kingiftcard is waiting. Let every purchase bring you
            closer to what’s next!
          </p>
        </div>
        <div class="level-logos">
          <div class="loyalty-container">
            @for (level of loyaltyLevels; track level; let i = $index) {
              <div
                class="loyalty"
                (mouseenter)="hoveredLevelIndex = i"
                (mouseleave)="hoveredLevelIndex = -1"
                >
                <span class="level">{{ level.level }}</span>
                <div class="logo-container">
                  <img src="{{ level.icon }}" alt="{{ level.level }}" />
                </div>
              </div>
            }

            @for (level of loyaltyLevels; track level; let i = $index) {
              <div
                [style.top]="level.top"
                [style.right]="level.right"
              [style.opacity]="
                isMobileView ? 1 : hoveredLevelIndex === i ? 1 : 0
              "
                class="percentage"
                >
                <div class="icon-container">
                  <img src="{{ kingAssets.Percentage }}" alt="percentage icon" />
                </div>
                <span
                  >Up To
                  <span>{{ level.percentage }}%</span>
                </span>
              </div>
            }
          </div>
        </div>
      </section>

      <section class="why-king-club">
        <h2 class="font-regular">
          Why Choose <span class="blue-keyword">KingClub</span>
        </h2>
        <p class="text-b2 font-regular">
          KingClub is designed to make your shopping experience smarter, more
          rewarding, and hassle-free.
        </p>
        <div class="why-king-club-items">
          @for (item of whyKingClubItems; track item) {
            <div class="why-king-club-card">
              <div class="why-king-club-card-container">
                @if (!isMobileView) {
                  <div class="front-side">
                    <span>{{ item.title }}</span>
                  </div>
                }
                <div class="back-side">
                  <span>{{ item.title }}</span>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
          }
        </div>
      </section>

      <section class="banner">
        <div class="banner-box">
          <span>Start Saving Today</span>
          <p>
            Join KingClub now and turn your everyday shopping into big savings.
          </p>
          <button mat-button (click)="joinKingClubBtnClicked()">
            @if (isMobileView) {
              Join Now
            }
            @if (!isMobileView) {
              Get Started Now
            }
          </button>
        </div>
      </section>

      <section class="how-works">
        <h2 class="font-regular">
          How KingClub <span class="blue-keyword">Reward System</span> Works
        </h2>

        <div class="process-container">
          @for (item of howKingClubWorksItems; track item; let i = $index) {
            <div [ngClass]="'step' + (i + 1)">
              <div class="process-marker-container">
                <div class="horizontal-line"></div>
                <div class="logo-container">
                  <img src="{{ item.icon }}" alt="step{{ i + 1 }} icon" />
                </div>
              </div>
              <div class="process-content">
                <span #span1 class="process-title">
                  {{ i + 1 }}. &nbsp;{{ item.title }}
                </span>
                <span #span2 class="process-description">
                  {{ item.description }}
                </span>
              </div>
            </div>
          }
        </div>
      </section>

      <!-- <section class="testimonial">
      <h2 class="font-regular">
        What Our <span class="blue-keyword">Testimonials</span> Are Saying
      </h2>
      <div #testimonialContainer [class.testimonial-carousel]="isMobileView">
        <div class="testimonial-container" id="testimonialContainer">
          <ng-container *ngFor="let item of testimonials">
            {{ item.commemt }}
            <div class="testimonial-box">
              <p>{{ item.comment }}</p>
              <div class="user-info">
                <img src="{{ item.avatar }}" alt="avatar" />
                <span>{{ item.user }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="scroll-buttons" *ngIf="isMobileView">
        <button mat-button class="scroll-button scroll-left" (click)="scrollLeft()">
          ←
        </button>
        <ul class="pagination-dots">
          <li
            *ngFor="let dot of testimonials; let i = index"
            [class.active]="activeIndex === i"
          ></li>
        </ul>
        <button mat-button class="scroll-button scroll-right" (click)="scrollRight()">
          →
        </button>
      </div>
    </section> -->

    <section class="faq">
      <h2 class="font-regular">Frequently Asked Questions</h2>
      <div class="faq-container" role="group" aria-labelledby="AccID">
        <div class="faq-col">
          @for (item of col1; track item; let i = $index) {
            <details
              [attr.open]="expandedFaqIndex === i ? '' : null"
              class="faq-item"
              >
              <summary (click)="toggleFaq($event, i)">
                <span>{{ item.question }}</span>
                <img
                  src="{{
                    i === expandedFaqIndex
                      ? kingAssets.ChevronUpBlue
                      : kingAssets.ChevronDownGrey
                  }}"
                  alt="{{
                    item.isExpanded ? 'faq expanded icon' : 'faq collapsed icon'
                  }}"
                  />
                </summary>
                <div
                  class="faq-content"
                  >
                  <div class="faq-content-inner">
                    <hr />
                    <p>{{ item.answer }}</p>
                  </div>
                </div>
              </details>
            }
          </div>
          <div class="faq-col">
            @for (item of col2; track item; let i = $index) {
              <details
                class="faq-item"
                [attr.open]="expandedFaqIndex === i + col1.length ? '' : null"
                >
                <summary (click)="toggleFaq($event, i + col1.length)">
                  <span>{{ item.question }}</span>
                  <img
                  src="{{
                    i + col1.length === expandedFaqIndex
                      ? kingAssets.ChevronUpBlue
                      : kingAssets.ChevronDownGrey
                  }}"
                  alt="{{
                    item.isExpanded ? 'faq expanded icon' : 'faq collapsed icon'
                  }}"
                    />
                  </summary>
                  <div
                    class="faq-content"
                    >
                    <div class="faq-content-inner">
                      <hr />
                      <p>{{ item.answer }}</p>
                    </div>
                  </div>
                </details>
              }
            </div>
          </div>
        </section>
      </main>

      <footer>
        <app-footer></app-footer>
      </footer>
    </div>
